export class WizardStep {
    complete: boolean = false;
    active: boolean = false;
}
